// services/Recruit/services/emailTemplateService.js
import { getApi, postApi, putApi, deleteApi } from 'common/services/api';

class EmailTemplateService {
    // Templates
    async createTemplate(data) {
        const response = await postApi('api/recruitment/email-templates', data);
        return response.data;
    }

    async getTemplates(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        const path = queryString ? `api/recruitment/email-templates?${queryString}` : 'api/recruitment/email-templates';
        const response = await getApi(path);
        return response.data;
    }

    async getTemplate(id) {
        const response = await getApi(`api/recruitment/email-templates/${id}`);
        return response.data;
    }

    async updateTemplate(id, data) {
        const response = await putApi(`api/recruitment/email-templates/${id}`, data);
        return response.data;
    }

    async deleteTemplate(id) {
        const response = await deleteApi(`api/recruitment/email-templates/${id}`, '');
        return response.data;
    }

    async deleteManyTemplates(ids) {
        const response = await postApi('api/recruitment/email-templates/deleteMany', ids);
        return response.data;
    }

    async duplicateTemplate(id) {
        const response = await postApi(`api/recruitment/email-templates/${id}/duplicate`, {});
        return response.data;
    }

    async sendEmailWithTemplate(templateId, data) {
        const response = await postApi(`api/recruitment/email-templates/${templateId}/send`, data);
        return response.data;
    }
}

// Fix: Assign to variable before exporting
const emailTemplateService = new EmailTemplateService();
export default emailTemplateService;

